export type FeatureRegistry = {
  priceAdministration: boolean;
  userManagement: boolean;
  roleManagement: boolean;
  approvalWorkflowAdministration: boolean;
  reapprovalUi: boolean;
  advancedAudit: boolean;
  contractGenerator: boolean;
  quoteDuplication: boolean;
  quoteShareLink: boolean;
  approvalCancellation: boolean;
  clientStatusManagement: boolean;
};

export type FeatureName = keyof FeatureRegistry;

type FeatureEnvironment = Partial<Record<
  | 'VITE_FEATURE_PRICE_ADMIN'
  | 'VITE_FEATURE_USER_MANAGEMENT'
  | 'VITE_FEATURE_ROLE_MANAGEMENT'
  | 'VITE_FEATURE_APPROVAL_WORKFLOW_ADMIN'
  | 'VITE_FEATURE_REAPPROVAL_UI'
  | 'VITE_FEATURE_ADVANCED_AUDIT'
  | 'VITE_FEATURE_CONTRACT_GENERATOR'
  | 'VITE_FEATURE_QUOTE_DUPLICATION'
  | 'VITE_FEATURE_QUOTE_SHARE_LINK'
  | 'VITE_FEATURE_APPROVAL_CANCELLATION'
  | 'VITE_FEATURE_CLIENT_STATUS_MANAGEMENT',
  string
>>;

export function parseFeatureFlag(value: string | undefined): boolean {
  return value?.trim().toLowerCase() === 'true';
}

export function createFeatureRegistry(environment: FeatureEnvironment): FeatureRegistry {
  return {
    priceAdministration: parseFeatureFlag(environment.VITE_FEATURE_PRICE_ADMIN),
    userManagement: parseFeatureFlag(environment.VITE_FEATURE_USER_MANAGEMENT),
    roleManagement: parseFeatureFlag(environment.VITE_FEATURE_ROLE_MANAGEMENT),
    approvalWorkflowAdministration: parseFeatureFlag(environment.VITE_FEATURE_APPROVAL_WORKFLOW_ADMIN),
    reapprovalUi: parseFeatureFlag(environment.VITE_FEATURE_REAPPROVAL_UI),
    advancedAudit: parseFeatureFlag(environment.VITE_FEATURE_ADVANCED_AUDIT),
    contractGenerator: parseFeatureFlag(environment.VITE_FEATURE_CONTRACT_GENERATOR),
    quoteDuplication: environment.VITE_FEATURE_QUOTE_DUPLICATION === undefined || parseFeatureFlag(environment.VITE_FEATURE_QUOTE_DUPLICATION),
    quoteShareLink: parseFeatureFlag(environment.VITE_FEATURE_QUOTE_SHARE_LINK),
    approvalCancellation: parseFeatureFlag(environment.VITE_FEATURE_APPROVAL_CANCELLATION),
    clientStatusManagement: parseFeatureFlag(environment.VITE_FEATURE_CLIENT_STATUS_MANAGEMENT),
  };
}

export const features = createFeatureRegistry(import.meta.env);
